import { render, staticRenderFns } from "./reAssignPOS.vue?vue&type=template&id=262ffd20&"
import script from "./reAssignPOS.vue?vue&type=script&lang=js&"
export * from "./reAssignPOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports